var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1541 0.846191H1.8464C1.34794 0.846191 0.88647 1.04934 0.535701 1.38165C0.203393 1.73242 0.000244141 2.19388 0.000244141 2.69235V19.3077C0.000244141 19.8062 0.203393 20.2677 0.535701 20.6184C0.88647 20.9507 1.34794 21.1539 1.8464 21.1539H22.1541C22.6525 21.1539 23.114 20.9507 23.4648 20.6184C23.7971 20.2677 24.0002 19.8062 24.0002 19.3077V2.69235C24.0002 2.19388 23.7971 1.73242 23.4648 1.38165C23.114 1.04934 22.6525 0.846191 22.1541 0.846191ZM1.8464 2.69235H6.46178V19.3077H1.8464V2.69235ZM22.1541 19.3077H8.30794V2.69235H22.1541V19.3077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleIcon);
export default __webpack_public_path__ + "static/media/toggle-icon.c86edf7a1a0e932a22e824b0d4972507.svg";
export { ForwardRef as ReactComponent };